import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { grey } from '@mui/material/colors';

export default function PdfPreview({pdfUrl}) {
  if (pdfUrl) {
    return <object type="application/pdf" data={pdfUrl + "#page=1&zoom=125"} width="100%" height="100%"/>
  }

  return (
    <Box width="100%" height="100%" display="inline-flex" justifyContent="center" alignItems="center" border='1px grey solid' backgroundColor={ grey[400] }>
      <Typography fontSize={30}>PDF作成中</Typography>
    </Box>      
  )
}